
/*iframe 嵌套逻辑*/
export const isFrame = () => {
  return window.top !== window.self
}

export const jumpHandler = ({userId, router})=>{
    router.push({path:'/workload/report/employee',query:{userId}})
}



// WEBPACK FOOTER //
// ./src/utils/other.js